import React from 'react';
import "./VerificationEmail.scoped.scss";

const VerificationEmail = () => {
  return (
    <h2 className="verification-email__text">Ваша почта подтверждена</h2>
  );
};

export default VerificationEmail;